const OVERALL_PERFORMANCE_Y_OFFSET = 0.85;
const DIMENSION_Y_OFFSET = 2.26;
const DIMENSION_X_OFFSET = 3.04;
const DIMENSION_STAT_Y_OFFSET = 0.18;

export const applyOverallPerformanceYOffset = (index: number) =>
  OVERALL_PERFORMANCE_Y_OFFSET * index;

export const applyDimensionYOffset = (index: number) =>
  DIMENSION_Y_OFFSET * Math.floor(index / DIMENSIONS_PER_ROW);

export const applyDimensionXOffset = (index: number) =>
  DIMENSION_X_OFFSET * (index % DIMENSIONS_PER_ROW);

export const applyDimensionMetricYOffset = (index: number) =>
  DIMENSION_STAT_Y_OFFSET * index;

const DIMENSIONS_PER_ROW = 3;
const DIMENSIONS_PER_COLUMN = 2;
export const TOTAL_DIMENSIONS = DIMENSIONS_PER_ROW * DIMENSIONS_PER_COLUMN;
